<script>
    import Stamp from "../components/images/Stamp.svelte";

    import AddDevice from "../components/devices/AddDevice.svelte";
    import StampsList from "../components/stamps/StampsList.svelte";
    import { business, user } from "../firebase/auth";
    import { Timestamp, addDoc, collection, deleteDoc, deleteField, doc, getDoc, onSnapshot, orderBy, query, serverTimestamp, setDoc, startAt, updateDoc, where } from "firebase/firestore";
    import { db } from "../firebase/firestore";

    const stampsRef = collection(db, "stamps");
    const q = query(stampsRef, where("business", "==", $business.id), orderBy("created"));
    
    let stamps = [];
    let loading = false;

    let unsub = onSnapshot(q, ((snap) => {
        stamps = [];
        snap.forEach((doc) => {
            let stamp = {id: doc.id, ...doc.data()};
            stamps.push(stamp);
        })
        stamps = stamps;
    }))

    function add(e) {
        const stamp = e.detail;
        const rarities = {};
        e.detail.available_rarities.forEach((r) => {
            rarities[r] = {
                count: 0,
                effect: r==="common"?"none":"shiny"
            }
        })
        try {
            const x = addDoc(stampsRef, {
                business: $business.id,
                created: serverTimestamp(),
                state: "active",
                rarities,
                ...stamp
            })
            console.log(x);
            // update business rarity settings
        } catch (error) {
            console.log(error);
        }
    }

    async function edit(e) {
        const stamp = e.detail;
        const rarities = {};
        e.detail.available_rarities.forEach((r) => {
            rarities[r] = {
                count: 0,
                effect: r==="common"?"none":"shiny"
            }
        });
        console.log(rarities);
        console.log("id:", e.detail.id);
        // debug, why rarities does not get updated

        let editRef = doc(db, "stamps", e.detail.id);
        try {
            await updateDoc(editRef, {
                ...stamp,
                rarities
            });
        } catch (error) {
            console.log(error);
        }
    }

    function remove(e) {
        try {
            console.log(e.detail.id);
            deleteDoc(doc(db, "stamps", e.detail.id));
            // update business rarity settings
        } catch (error) {
            console.log(error);
            loading = false;
        }
    }
</script>


{#if $business}
    <h1>Stempel</h1>
    <p>Lege bis zu 20 Stempel an, von denen immer einer zufällig vergeben wird. Wir <b>empfehlen 5 bis 10 Stempel</b> anzulegen, damit das Sammeln mehr Spaß macht (bis zu 20 sind möglich).</p>
    
    <StampsList bind:stamps on:remove={remove} on:edit={edit} on:add={add}/>
{/if}